import { render, staticRenderFns } from "./myrealtestchart.vue?vue&type=template&id=fc0f0d54&scoped=true"
import script from "./myrealtestchart.vue?vue&type=script&lang=js"
export * from "./myrealtestchart.vue?vue&type=script&lang=js"
import style0 from "./myrealtestchart.vue?vue&type=style&index=0&id=fc0f0d54&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0f0d54",
  null
  
)

export default component.exports